import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { CountryFlag as CountryFlagComponent } from 'src/components/country-flag';
import { FontWeight } from '@prisjakt/ui/text';

export const Sites = styled.ul`
  list-style: none;
  width: 100%;
  margin: 0;
  line-height: unset;
`;

export const Link = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${layout.measurements.spacing050} ${layout.measurements.spacing075};
`;

export const Site = styled.li`
  transition: background ${layout.animations.buttonTransition};

  &:hover {
    background: ${p => p.theme.dropdowns.primary.hoverBackground};
  }
`;

export const CountryNameWrapper = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1.75;
  max-width: 15rem;

  &:active {
    color: ${p => p.theme.text.primary};
  }
`;

export const CountryFlag = styled(CountryFlagComponent)`
  margin-right: ${layout.measurements.spacing050};
  flex: 0 1 auto;
`;

export const CountryName = styled.span`
  font-weight: ${FontWeight.HEAVIER};
`;
